import React from "react";
import { Receipt } from "lucide-react";
import { PAINEL_ICON_BTN_CLASS, PAINEL_ICON_SIZE } from "./PainelIconButton";

interface PainelPedidoOriginalButtonProps {
  orderId: number;
  onOpen: (orderId: number) => void;
  compact?: boolean;
}

export const PainelPedidoOriginalButton: React.FC<
  PainelPedidoOriginalButtonProps
> = ({ orderId, onOpen, compact = false }) => {
  return (
    <button
      type="button"
      onClick={() => onOpen(orderId)}
      className={`${compact ? "inline-flex size-7 shrink-0 items-center justify-center rounded-md" : PAINEL_ICON_BTN_CLASS} border border-blue-600 bg-blue-600 text-white shadow-sm transition hover:border-blue-700 hover:bg-blue-700`}
      title="Ver pedido original (integração)"
      aria-label="Ver pedido original da integração"
    >
      <Receipt size={compact ? 14 : PAINEL_ICON_SIZE} strokeWidth={2} />
    </button>
  );
};
